import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig from '@/api/useGetFetchConfig';
import { Org } from '@/types';

const useFetchOrganisations = (enabled: boolean = false) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<Org[]>(
    'fetchOrgs',
    () => {
      const url = new URL(`${APIBaseChronos}/api/org/all`);

      return fetch(url.toString(), fetchConfigGET)
        .then((res) => res.json())
        .catch((err) => {
          console.error(err);
        });
    },
    {
      cacheTime: 0,
      enabled: enabled,
      refetchOnWindowFocus: false,
    },
  );
};

export default useFetchOrganisations;
